import { FETCH_MTOKNA_EXCEL_SCHEMES, CLEAN_MTOKNA_EXCEL_SCHEMES, CHANGE_MTOKNA_EXCEL_SCHEME, DELETE_MTOKNA_EXCEL_SCHEME } from '../actions/types';
import _ from 'lodash';
import { toNumber } from '../functions';

const MTOKNA_EXCEL_SCHEMES_DEFAULT_STATE = {};

const MtoknaExcelSchemesReducer = (state = MTOKNA_EXCEL_SCHEMES_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_MTOKNA_EXCEL_SCHEMES:
            return payload;

        case CHANGE_MTOKNA_EXCEL_SCHEME:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, data: payload.data };
                }

                return item;
            }) };

        case CLEAN_MTOKNA_EXCEL_SCHEMES:
        case DELETE_MTOKNA_EXCEL_SCHEME:
            return MTOKNA_EXCEL_SCHEMES_DEFAULT_STATE;

        default:
            return state;
    }
};

export default MtoknaExcelSchemesReducer;
